/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CardMixResponse } from '../models';
// @ts-ignore
import type { CheckoutFunnelResponse } from '../models';
// @ts-ignore
import type { DashboardSummaryResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MetricSeriesResponse } from '../models';
// @ts-ignore
import type { Processor } from '../models';
/**
 * MerchantDashboardApi - axios parameter creator
 * @export
 */
export const MerchantDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns checkout funnel analytics for a single merchant, showing session drop-off and completion metrics over a date range.  The merchant is the scope, so there is no merchant filter parameter. A partner wanting the funnel for one of its merchants uses the partner endpoint with `merchantIds`. 
         * @summary Get checkout funnel analytics for a merchant
         * @param {string} merchantId Merchant identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts the funnel to checkout sessions routed to one processor. Omit to include every session, which is the default.  Sessions whose processor had not been resolved when they were created are counted only in the unfiltered funnel. The per-processor funnels therefore need not sum to the unfiltered one; the difference is the set of unresolved sessions.  Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCheckoutFunnel: async (merchantId: string, fromDate: string, toDate: string, processor?: Processor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantCheckoutFunnel', 'merchantId', merchantId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getMerchantCheckoutFunnel', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getMerchantCheckoutFunnel', 'toDate', toDate)
            const localVarPath = `/api/v1/merchants/{merchantId}/dashboard/checkout-funnel`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (processor !== undefined) {
                localVarQueryParameter['processor'] = processor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) for a single merchant, with sales volume, fee volume, and percentage shares per category. 
         * @summary Get card mix breakdown by card category for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardCardMix: async (merchantId: string, fromDate: string, toDate: string, processor?: Processor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantDashboardCardMix', 'merchantId', merchantId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getMerchantDashboardCardMix', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getMerchantDashboardCardMix', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/dashboard/card-mix`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (processor !== undefined) {
                localVarQueryParameter['processor'] = processor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time series data for any dashboard metric scoped to a single merchant, suitable for charting. Uses uniform-bucket bucketing; intervals defaults to 5. 
         * @summary Get time series data for a specific dashboard metric for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {GetMerchantDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {string} [currency] Denominates the series. Every bucket is a sum of minor units, so a series can carry exactly ONE currency — supply this whenever the range may hold more than one.  Omit it and the endpoint resolves the currency itself: it uses the only currency in range when there is one, and refuses with &#x60;MULTI_CURRENCY_METRIC_SERIES&#x60; when there is more than one, rather than adding amounts in different denominations together and labelling the total with a single code. A range with no rows at all reports USD, which denominates nothing because every bucket is zero. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardMetricSeries: async (merchantId: string, metric: GetMerchantDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, intervals?: number, processor?: Processor, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantDashboardMetricSeries', 'merchantId', merchantId)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getMerchantDashboardMetricSeries', 'metric', metric)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getMerchantDashboardMetricSeries', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getMerchantDashboardMetricSeries', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/dashboard/metric-series`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (intervals !== undefined) {
                localVarQueryParameter['intervals'] = intervals;
            }

            if (processor !== undefined) {
                localVarQueryParameter['processor'] = processor;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated financial metrics for a single merchant over a date range.
         * @summary Get aggregated dashboard summary metrics for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardSummary: async (merchantId: string, fromDate: string, toDate: string, processor?: Processor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantDashboardSummary', 'merchantId', merchantId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getMerchantDashboardSummary', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getMerchantDashboardSummary', 'toDate', toDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/dashboard/summary`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (processor !== undefined) {
                localVarQueryParameter['processor'] = processor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantDashboardApi - functional programming interface
 * @export
 */
export const MerchantDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns checkout funnel analytics for a single merchant, showing session drop-off and completion metrics over a date range.  The merchant is the scope, so there is no merchant filter parameter. A partner wanting the funnel for one of its merchants uses the partner endpoint with `merchantIds`. 
         * @summary Get checkout funnel analytics for a merchant
         * @param {string} merchantId Merchant identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts the funnel to checkout sessions routed to one processor. Omit to include every session, which is the default.  Sessions whose processor had not been resolved when they were created are counted only in the unfiltered funnel. The per-processor funnels therefore need not sum to the unfiltered one; the difference is the set of unresolved sessions.  Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantCheckoutFunnel(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutFunnelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantCheckoutFunnel(merchantId, fromDate, toDate, processor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantDashboardApi.getMerchantCheckoutFunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) for a single merchant, with sales volume, fee volume, and percentage shares per category. 
         * @summary Get card mix breakdown by card category for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantDashboardCardMix(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardMixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantDashboardCardMix(merchantId, fromDate, toDate, processor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantDashboardApi.getMerchantDashboardCardMix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns time series data for any dashboard metric scoped to a single merchant, suitable for charting. Uses uniform-bucket bucketing; intervals defaults to 5. 
         * @summary Get time series data for a specific dashboard metric for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {GetMerchantDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {string} [currency] Denominates the series. Every bucket is a sum of minor units, so a series can carry exactly ONE currency — supply this whenever the range may hold more than one.  Omit it and the endpoint resolves the currency itself: it uses the only currency in range when there is one, and refuses with &#x60;MULTI_CURRENCY_METRIC_SERIES&#x60; when there is more than one, rather than adding amounts in different denominations together and labelling the total with a single code. A range with no rows at all reports USD, which denominates nothing because every bucket is zero. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantDashboardMetricSeries(merchantId: string, metric: GetMerchantDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, intervals?: number, processor?: Processor, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricSeriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantDashboardMetricSeries(merchantId, metric, fromDate, toDate, intervals, processor, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantDashboardApi.getMerchantDashboardMetricSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregated financial metrics for a single merchant over a date range.
         * @summary Get aggregated dashboard summary metrics for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantDashboardSummary(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantDashboardSummary(merchantId, fromDate, toDate, processor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantDashboardApi.getMerchantDashboardSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantDashboardApi - factory interface
 * @export
 */
export const MerchantDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantDashboardApiFp(configuration)
    return {
        /**
         * Returns checkout funnel analytics for a single merchant, showing session drop-off and completion metrics over a date range.  The merchant is the scope, so there is no merchant filter parameter. A partner wanting the funnel for one of its merchants uses the partner endpoint with `merchantIds`. 
         * @summary Get checkout funnel analytics for a merchant
         * @param {string} merchantId Merchant identifier (ULID)
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts the funnel to checkout sessions routed to one processor. Omit to include every session, which is the default.  Sessions whose processor had not been resolved when they were created are counted only in the unfiltered funnel. The per-processor funnels therefore need not sum to the unfiltered one; the difference is the set of unresolved sessions.  Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCheckoutFunnel(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutFunnelResponse> {
            return localVarFp.getMerchantCheckoutFunnel(merchantId, fromDate, toDate, processor, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) for a single merchant, with sales volume, fee volume, and percentage shares per category. 
         * @summary Get card mix breakdown by card category for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardCardMix(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): AxiosPromise<CardMixResponse> {
            return localVarFp.getMerchantDashboardCardMix(merchantId, fromDate, toDate, processor, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time series data for any dashboard metric scoped to a single merchant, suitable for charting. Uses uniform-bucket bucketing; intervals defaults to 5. 
         * @summary Get time series data for a specific dashboard metric for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {GetMerchantDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {string} [currency] Denominates the series. Every bucket is a sum of minor units, so a series can carry exactly ONE currency — supply this whenever the range may hold more than one.  Omit it and the endpoint resolves the currency itself: it uses the only currency in range when there is one, and refuses with &#x60;MULTI_CURRENCY_METRIC_SERIES&#x60; when there is more than one, rather than adding amounts in different denominations together and labelling the total with a single code. A range with no rows at all reports USD, which denominates nothing because every bucket is zero. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardMetricSeries(merchantId: string, metric: GetMerchantDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, intervals?: number, processor?: Processor, currency?: string, options?: RawAxiosRequestConfig): AxiosPromise<MetricSeriesResponse> {
            return localVarFp.getMerchantDashboardMetricSeries(merchantId, metric, fromDate, toDate, intervals, processor, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated financial metrics for a single merchant over a date range.
         * @summary Get aggregated dashboard summary metrics for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantDashboardSummary(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig): AxiosPromise<DashboardSummaryResponse> {
            return localVarFp.getMerchantDashboardSummary(merchantId, fromDate, toDate, processor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantDashboardApi - object-oriented interface
 * @export
 * @class MerchantDashboardApi
 * @extends {BaseAPI}
 */
export class MerchantDashboardApi extends BaseAPI {
    /**
     * Returns checkout funnel analytics for a single merchant, showing session drop-off and completion metrics over a date range.  The merchant is the scope, so there is no merchant filter parameter. A partner wanting the funnel for one of its merchants uses the partner endpoint with `merchantIds`. 
     * @summary Get checkout funnel analytics for a merchant
     * @param {string} merchantId Merchant identifier (ULID)
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {Processor} [processor] Restricts the funnel to checkout sessions routed to one processor. Omit to include every session, which is the default.  Sessions whose processor had not been resolved when they were created are counted only in the unfiltered funnel. The per-processor funnels therefore need not sum to the unfiltered one; the difference is the set of unresolved sessions.  Any other value is rejected with a validation error naming the accepted values. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantDashboardApi
     */
    public getMerchantCheckoutFunnel(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig) {
        return MerchantDashboardApiFp(this.configuration).getMerchantCheckoutFunnel(merchantId, fromDate, toDate, processor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transaction breakdown by card category (Premium, Standard, Debit, Commercial) for a single merchant, with sales volume, fee volume, and percentage shares per category. 
     * @summary Get card mix breakdown by card category for a merchant
     * @param {string} merchantId Merchant identifier
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantDashboardApi
     */
    public getMerchantDashboardCardMix(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig) {
        return MerchantDashboardApiFp(this.configuration).getMerchantDashboardCardMix(merchantId, fromDate, toDate, processor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time series data for any dashboard metric scoped to a single merchant, suitable for charting. Uses uniform-bucket bucketing; intervals defaults to 5. 
     * @summary Get time series data for a specific dashboard metric for a merchant
     * @param {string} merchantId Merchant identifier
     * @param {GetMerchantDashboardMetricSeriesMetricEnum} metric Metric key. Valid values: total-revenue, total-transactions, avg-transaction, acceptance-percentage, refunds-percentage, estimated-savings, fans-saved 
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {number} [intervals] Number of uniform-width buckets to divide the date range into. When intervals &gt;&#x3D; totalDays the buckets are 1-day wide (daily view). Defaults to 5. 
     * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
     * @param {string} [currency] Denominates the series. Every bucket is a sum of minor units, so a series can carry exactly ONE currency — supply this whenever the range may hold more than one.  Omit it and the endpoint resolves the currency itself: it uses the only currency in range when there is one, and refuses with &#x60;MULTI_CURRENCY_METRIC_SERIES&#x60; when there is more than one, rather than adding amounts in different denominations together and labelling the total with a single code. A range with no rows at all reports USD, which denominates nothing because every bucket is zero. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantDashboardApi
     */
    public getMerchantDashboardMetricSeries(merchantId: string, metric: GetMerchantDashboardMetricSeriesMetricEnum, fromDate: string, toDate: string, intervals?: number, processor?: Processor, currency?: string, options?: RawAxiosRequestConfig) {
        return MerchantDashboardApiFp(this.configuration).getMerchantDashboardMetricSeries(merchantId, metric, fromDate, toDate, intervals, processor, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated financial metrics for a single merchant over a date range.
     * @summary Get aggregated dashboard summary metrics for a merchant
     * @param {string} merchantId Merchant identifier
     * @param {string} fromDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} toDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {Processor} [processor] Restricts results to activity processed on one payment processor. Omit to include every processor, which is the default. Any other value is rejected with a validation error naming the accepted values. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantDashboardApi
     */
    public getMerchantDashboardSummary(merchantId: string, fromDate: string, toDate: string, processor?: Processor, options?: RawAxiosRequestConfig) {
        return MerchantDashboardApiFp(this.configuration).getMerchantDashboardSummary(merchantId, fromDate, toDate, processor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMerchantDashboardMetricSeriesMetricEnum = {
    TotalRevenue: 'total-revenue',
    TotalTransactions: 'total-transactions',
    AvgTransaction: 'avg-transaction',
    AcceptancePercentage: 'acceptance-percentage',
    RefundsPercentage: 'refunds-percentage',
    EstimatedSavings: 'estimated-savings',
    FansSaved: 'fans-saved'
} as const;
export type GetMerchantDashboardMetricSeriesMetricEnum = typeof GetMerchantDashboardMetricSeriesMetricEnum[keyof typeof GetMerchantDashboardMetricSeriesMetricEnum];
